export const TEST_ID = 'tabPanelWarnings';
